import * as moment from 'moment';
import * as _ from 'lodash';
import { IMonthOption } from '../components/MonthlyFilter/MonthlyFilter';

export const getCurrentTime = (format?: string) =>
  moment().format(format || 'h:mm A');
export const getCurrentYear = () => moment().year();
export const momentAgeNow = (momentDate) => moment().diff(momentDate, 'years');
export const ageFromStringDate = (date: string) =>
  moment().diff(moment(date, 'DD/MM/YYYY'), 'years');
export const momentToMiliseconds = (momentDate) =>
  momentDate && momentDate.toDate().getTime();
export const momentToString = (momentDate) =>
  momentDate && momentDate.format('L');
export const momentAddDays = (date, amount: number) =>
  moment(date).add(amount, 'days');
export const timestampToMoment = (timestamp) => moment.unix(timestamp / 1000);
export const stringDateToLongFormat = (date: string) =>
  moment(date, 'DD/MM/YYYY').format('dddd, MMMM Do YYYY');
export const timestampToDateTimeString = (timestamp) =>
  timestampToMoment(timestamp).format('LLL');
export const timestampToLongDate = (timestamp: number) =>
  moment(timestamp).format('dddd, MMMM Do YYYY');
export const momentBirthDateAge = (age) =>
  moment().startOf('year').subtract(age, 'years');
export const timestampToWeekDay = (timestamp) =>
  timestampToMoment(timestamp).format('ddd');
export const timestampToDateTimeStringShort = (timestamp: number) => {
  const momentDate = timestampToMoment(timestamp);
  return momentToString(momentDate);
};
export const getUnixTimeStamp = () => moment().valueOf();
export const getIsWeekend = (epoch = moment().valueOf()) => {
  const day = moment(epoch, 'x').format('ddd');
  return day === 'Sat' || day === 'Sun' ? true : false;
};
export const displayEither = (data, substitute) => data || substitute;
export const displayIf = (data, substitute, conditional) =>
  conditional ? data : substitute;
export const getLoggedUserEmail = () => {
  const authToken = localStorage.getItem('icmec-auth');
  let email = '';
  if (authToken) {
    email = JSON.parse(authToken).idToken.payload.email;
  }
  return email;
};
export const capitalize = (text: string) =>
  `${text.charAt(0).toUpperCase()}${text.substr(1).toLocaleLowerCase()}`;
export const formatCapitalized = (fullName: string) => {
  try {
    const splited = fullName.toLowerCase().split(' ');
    return splited
      .map(
        (name, i) =>
          (splited[i] = `${name.charAt(0).toUpperCase()}${splited[i].substr(
            1
          )}`)
      )
      .join(' ');
  } catch (error) {
    return fullName;
  }
};

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const previousMonth = (date: Date, initialYear): IMonthOption => {
  const firstDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  const month = firstDate.getMonth();
  const lastDate = new Date(firstDate.getFullYear(), month + 1, 0);
  const year = lastDate.getFullYear();
  return {
    gte: firstDate.getTime(),
    lte: lastDate.getTime(),
    name: `${monthNames[month]} ${year !== initialYear ? year : ''}`,
  };
};

export const getOptions = () => {
  const now = new Date();
  const nowTime = now.getTime();
  const nowYear = now.getFullYear();
  const lastMonth: IMonthOption = {
    gte: nowTime - 1000 * 60 * 60 * 24 * 30,
    lte: nowTime,
    name: 'Last Month',
  };
  const all: IMonthOption = {
    gte: 0,
    lte: 0,
    name: 'All',
  };
  const monthsData = _.times(12).reduce(
    (months, __, index) => {
      const month = previousMonth(
        new Date(months[index].lte as number),
        nowYear
      );
      return [...months, month];
    },
    [previousMonth(now, nowYear)] as IMonthOption[]
  );
  return [all, lastMonth, ...monthsData];
};

export const getZoom = (radius: number) => {
  const zooms = {
    11: [5],
    10: [10],
    9: [15, 20],
    8: [25, 40],
    7: [45, 80],
    6: [85, 165],
    5: [170, 330],
    4: [335, 680],
    3: [685, 1000],
  };
  const zoom = Object.keys(zooms).find((z) => {
    const [min, max] = zooms[z];
    return max ? radius >= min && radius <= max : radius === min;
  });
  return Number(zoom);
};

export const RANDOMCOLORS = (size) =>
  [...Array(size).keys()].map(
    (index) => `#${Math.floor(Math.random() * 16777215).toString(16)}`
  );

export const getDaysDifferenceFromToday = (dateToCompare: number) => {
  const today = new Date().getTime();
  const difference = today - dateToCompare;
  const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
  return daysDifference;
};



// WEBPACK FOOTER //
// ./src/share/utils/utils.ts